import React, { useState } from 'react';
import styles from '../styles/ContactForm.module.css';

const MAX_HEADING = 50;
const MAX_SUB = 30;
const MAX_CTA = 10;

export default function ContactForm() {
  const [heading, setHeading] = useState('');
  const [subHeading, setSubHeading] = useState('');
  const [cta, setCta] = useState('');
  const [open, setOpen] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    //  can add our save logic here
    alert('Form saved!');
  };

  return (
    <div className={styles.formSection}>
      <div className={styles.headerRow} onClick={() => setOpen(o => !o)} style={{cursor: 'pointer'}}>
        <span className={styles.icon}><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg></span>
        <span className={styles.title}>Form</span>
        <span className={styles.dropdownIcon} style={{marginLeft: 'auto', transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)'}}>
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        </span>
      </div>
      {open && (
        <form onSubmit={handleSubmit}>
          <label className={styles.label}>
            Form heading
            <textarea
              className={styles.input}
              value={heading}
              onChange={e => setHeading(e.target.value.slice(0, MAX_HEADING))}
              rows={3}
              placeholder="Enter form heading"
            />
            <div className={styles.helper}>Max 50 characters including space</div>
          </label>
          <label className={styles.label}>
            Sub heading
            <input
              className={styles.input}
              value={subHeading}
              onChange={e => setSubHeading(e.target.value.slice(0, MAX_SUB))}
              placeholder="Enter sub heading"
            />
            <div className={styles.helper}>Max 30 characters including space</div>
          </label>
          <label className={styles.label}>
            CTA text
            <input
              className={styles.input}
              value={cta}
              onChange={e => setCta(e.target.value.slice(0, MAX_CTA))}
              placeholder="Write text here"
            />
            <div className={styles.helper}>Max 10 characters including space</div>
          </label>
          <button className={styles.saveBtn} type="submit">SAVE</button>
          <button className={styles.cancelBtn} type="button" onClick={() => setOpen(false)}>CANCEL</button>
        </form>
      )}
    </div>
  );
}
